/*
Точка входа в браузере.

Если сервер прислал готовую разметку, её нужно оживить, а не рисовать заново:
hydrateRoot переиспользует присланные узлы. createRoot вместо него стёр бы их
и свёл выигрыш к нулю.
*/
import { StrictMode } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import Root from './Root.jsx';

const initial = window.__SAINTS__ ?? null;
const container = document.getElementById('root');

/*
Содержимое, пришедшее с сервера, гасить нельзя.

Правило .has-js [data-reveal] прячет блоки до появления. На пустом каркасе это
незаметно, но серверную разметку покупатель уже видит — и она мигнула бы:
показалась, исчезла, вернулась через 0.8 секунды. Ровно то, ради чего затевался
серверный рендеринг.

Поэтому всё, что уже на экране, помечаем показанным ДО включения класса — в том
же синхронном блоке, чтобы между ними не было ни одного кадра. Блоки ниже сгиба
остаются скрытыми и появляются при прокрутке, как раньше.
*/
if (initial && container.hasChildNodes()) {
  for (const el of container.querySelectorAll('[data-reveal]')) {
    const box = el.getBoundingClientRect();
    if (box.top < window.innerHeight && box.bottom > 0) el.classList.add('is-in');
  }
  for (const line of container.querySelectorAll('.split-line')) {
    const box = line.getBoundingClientRect();
    if (box.top < window.innerHeight && box.bottom > 0) line.classList.add('is-in');
  }
}

// Пока JS не выполнился, ничего не скрываем — содержимое видно даже при сбое
document.documentElement.classList.add('has-js');

const tree = (
  <StrictMode>
    <BrowserRouter>
      <Root initial={initial} />
    </BrowserRouter>
  </StrictMode>
);

// Разметка с сервера есть — оживляем; иначе рисуем с нуля
if (initial && container.hasChildNodes()) {
  hydrateRoot(container, tree);
} else {
  createRoot(container).render(tree);
}
